import { Helmet } from "react-helmet";
import { Link } from "react-router";

const PageNotFound = () => {
  return (
    <main>
      <Helmet>
        <title>Page Not Found | Provido</title>
        <meta property="og:title" content="Page Not Found | Provido" />
        <meta
          name="description"
          content="404: this page does not exist."
        ></meta>
        <meta name="twitter:title" content="Page Not Found | Provido" />
      </Helmet>

      {/* Page Header */}
      <div className="w-dvw bg-lightblue bg-[url(./assets/images/bubblebg.webp)] py-12">
        <div className="px-12 pb-6 text-center font-display text-6xl leading-18 text-blue sm:pb-0">
          Page Not Found
        </div>
      </div>
      <p className="my-12 px-12 text-center">
        Oops, looks like the page you're looking for doesn't exist. If you think
        this is an error, please feel free to{" "}
        <Link to="/contact" className="text-link">
          contact us
        </Link>
        .
      </p>
    </main>
  );
};

export default PageNotFound;
